.compactFacts {
  display: none;
  min-width: 0;
  flex-direction: column;
  gap: 0.1em;
}

.incomplete {
  color: var(--warning-text);
}

.compactFact {
  min-width: 0;
  margin: 0;
  font-size: 0.7em;
  color: var(--ink-muted);
}

.failedItem {
  min-width: 0;
  margin: 0;
  color: var(--ink-primary);
  font-size: 0.85em;
  font-weight: 600;
}

.evidence,
.freshness {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.1em;
}

@container panel (max-width: 13rem) and (min-height: 24rem) {
  .statusAnchor :global([class*="status"]) {
    font-size: 1.7em;
  }

  .compactFacts {
    display: flex;
  }

  .fullSummary {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}

@container panel (max-width: 13rem) and (max-height: 10rem) {
  :global([data-density="compact"]) .compactFacts ~ :global([data-panel-meta]) {
    display: none;
  }
}
